(() => {
	angular
		.module('main')
		.controller('GoogleAutocompleteController', GoogleAutocompleteController);

	GoogleAutocompleteController.$inject = ['$scope', '$rootScope'];

	function GoogleAutocompleteController($scope, $rootScope) {
		$scope.result = '';
		$scope.options = {};
		$scope.defaultLocation = 'Lviv';

		$scope.formGeocode = {
			type: 'geocode',
			bounds: {
				SWLat: 49,
				SWLng: -97,
				NELat: 50,
				NELng: -96
			},
			country: 'ca',
			typesEnabled: false,
			boundsEnabled: false,
			componentEnabled: false,
			watchEnter: true,
			foundLocation: $rootScope.jobLocation
		};

		// watch form for changes
		$scope.watchForm = function() {
			return $scope.formGeocode;
		};
		$scope.$watch(
			$scope.watchForm,
			() => {
				$scope.checkForm();
			},
			true
		);

		// set options from form selections
		$scope.checkForm = function() {
			$scope.options = {};

			$scope.options.watchEnter = $scope.formGeocode.watchEnter;

			$scope.options.foundLocation = $rootScope.jobLocation;

			if ($scope.formGeocode.typesEnabled) {
				$scope.options.types = $scope.formGeocode.type;
			}
			if ($scope.formGeocode.boundsEnabled) {
				const SW = new google.maps.LatLng(
					$scope.formGeocode.bounds.SWLat,
					$scope.formGeocode.bounds.SWLng
				);
				const NE = new google.maps.LatLng(
					$scope.formGeocode.bounds.NELat,
					$scope.formGeocode.bounds.NELng
				);
				const bounds = new google.maps.LatLngBounds(SW, NE);
				$scope.options.bounds = bounds;
			}
			if ($scope.formGeocode.componentEnabled) {
				$scope.options.country = $scope.formGeocode.country;
			}
		};

		const listenerAutocomplete = (newValue, oldValue) => {
			if (newValue === oldValue) {
				return;
			}
			$scope.$parent.job.location = newValue;
		};

		$scope.$watch('autocomplete', listenerAutocomplete);

		const listenerSetDeaultLocation = (newValue, oldValue) => {
			if (newValue === oldValue) {
				return;
			}
			$scope.autocomplete = newValue;
		};

		$scope.$parent.$watch('job.location', listenerSetDeaultLocation);
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/googleAutocompleteController.js